import { tournamentPredictionSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const predictions = {
	forTournament: (tournamentId: string) =>
		fetchApi(`/tournaments/${tournamentId}/predictions`, tournamentPredictionSchema),
};
